export default __webpack_public_path__ + "static/media/st_john.12442519.png";